import React from "react";
import PropTypes from "prop-types";
import LayoutContextProvider from "./LayoutContextProvider";
import SidebarContextProvider from "./SidebarContextProvider";
import ThemeContextProvider from "./ThemeContextProvider";
import { SidebarCollapseProvider } from "../SidebarCollapseContext";

const AppContextProvider = ({ children }) => {
  return (
    <ThemeContextProvider>
      <LayoutContextProvider>
        <SidebarContextProvider>
          <SidebarCollapseProvider>{children}</SidebarCollapseProvider>
        </SidebarContextProvider>
      </LayoutContextProvider>
    </ThemeContextProvider>
  );
};

export default AppContextProvider;

AppContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
